export enum FIELD_ALIGN {
  LEFT = 'left',
  RIGHT = 'right',
}
